import type { Transaction } from "@rocicorp/zero";
import { zql, type Schema } from "./generatedDrizzleSchema";
import {
  PERSONAL_WORK_DISABLED_MESSAGE,
  isPersonalWorkEnabled,
} from "./personalWork";
import { type Permission, scopeKindOf } from "./rbac/permissions";
import { userFacingError } from "./userFacingError";

type ReadTransaction = Pick<Transaction<Schema>, "run">;

export async function personalWorkAllowsSpacePermission({
  tx,
  tenantId,
  scopeId,
  permission,
}: {
  tx: ReadTransaction;
  tenantId: string;
  scopeId: string;
  permission: Permission;
}): Promise<boolean> {
  if (scopeKindOf(permission) !== "space") return true;

  const [space] = await tx.run(
    zql.spaces.where("id", scopeId).where("tenantId", tenantId)
  );
  if (space?.mode !== "personal") return true;

  const tenant = await tx.run(zql.tenants.where("id", tenantId).one());
  return tenant != null && isPersonalWorkEnabled(tenant);
}

export async function assertPersonalWorkEnabled(
  tx: ReadTransaction,
  tenantId: string
): Promise<void> {
  const tenant = await tx.run(zql.tenants.where("id", tenantId).one());
  if (!tenant || !isPersonalWorkEnabled(tenant)) {
    throw userFacingError(PERSONAL_WORK_DISABLED_MESSAGE);
  }
}
